import { AbstractControl } from '@angular/forms';

export function phoneNumberValidator(control: AbstractControl) {
  const PHONE_NUMBER_REGEX = /^\d{3}-\d{3}-\d{4}$/;
  const value = control.value?.trim();

  return PHONE_NUMBER_REGEX.test(value) ? null : { phoneNumber: true };
}
